import { render } from "./index.vue?vue&type=template&id=d273538c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=d273538c&scoped=true&lang=css"
import "./index.vue?vue&type=style&index=1&id=d273538c&lang=css"

import exportComponent from "/workspace/office-website/company-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d273538c"]])

export default __exports__